import { useState } from "react";
import { toast } from "react-toastify";
import callApi from "../../../../utility/apiCaller";
import { setUserClickData } from "../../../../utility/setUserClickData";


export const ContactForm = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    mobile: "",
    email: "",
    message: ""
  });

  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async () => {
    if (!formData.fullName || !formData.mobile || !formData.email || !formData.message) {
      toast.error("Please fill in all fields.");
      return;
    }

    // Toast on submit
    toast.info("Submitting your request...");

    setUserClickData({
      event_name: "contact-us-form-submit-clicked",
      user_id: formData.mobile || "unknown",
      timestamp: new Date().toISOString(),
    });

    setIsLoading(true);
    try {
      const response = await callApi(
        "v1/whatsapp_unsubscribe/contact-us",
        "post",
        {
          client_reference_id: "b5FJWURpS9uaJs5S19ia", // Hardcoded
          data: {
            contact_phone: formData.mobile,
            name: formData.fullName,
            email: formData.email,
            message: formData.message,
          },
        },
        "messaging",
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2NGE1NGRkOWZiMTA5OTMzZjg4MzY0MDciLCJjb250YWN0X2VtYWlsIjoicmFnaHZlbmRyYS5tb2RhbndhbEBhbnRjcmVhdGl2ZXMuY29tIiwiY29udGFjdF9uYW1lIjoiUmFnaGF2IiwiY29udGFjdF9waG9uZSI6Ijg3NTY4MDk4NzgiLCJpYXQiOjE2ODg1NTUyNzR9.sMRhMGvaYTcNEIiuMPvBl1j_VhiKt8mi3gDmQRuLU",
        
      );

      if (response.status === "Success") {
        setUserClickData({
          event_name: "contact-us-form-submit-success",
          user_id: formData.mobile || "unknown",
          timestamp: new Date().toISOString(),
        });
        toast.success("Your request has been submitted successfully!");
        setFormData({ fullName: "", mobile: "", email: "", message: "" }); // reset form
      } else {
        toast.error(response?.data?.message || "Something went wrong.");
      }
    } catch (error) {
      console.error("Error while submitting Contact Us form:", error);
      toast.error("Unable to submit the form. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="rounded-lg p-6 xs:p-1 md:p-8">
      <h2 className="text-2xl font-bomstad font-bold text-gray-800 mb-6">
        Request a Call Back
      </h2>

      <div className="space-y-6 font-atkinson text-gray-800">
        <div>
          <label className="block text-lg font-medium text-[#7A7A7A] mb-2">
            Full Name
          </label>
          <input
            type="text"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            className="w-full max-w-[370px] text-lg px-4 py-2.5 border-1 border-[#aaa8a8] outline-none rounded-lg focus:ring-2 focus:ring-gray-700 focus:border-gray-700 transition-colors"
            placeholder="Enter your full name"
          />
        </div>

        <div>
          <label className="block text-lg font-medium text-[#7A7A7A] mb-2">
            Mobile Number
          </label>
          <input
            type="tel"
            name="mobile"
            value={formData.mobile}
            onChange={handleChange} 
            maxLength={10}
            className="w-full max-w-[370px] text-lg px-4 py-2.5 border-1 border-[#aaa8a8] outline-none rounded-lg focus:ring-2 focus:ring-gray-700 focus:border-gray-700 transition-colors"
            placeholder="Enter your mobile number"
          />
        </div>

        <div>
          <label className="block text-lg font-medium text-[#7A7A7A] mb-2">
            Email ID
          </label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full  max-w-[370px] text-lg px-4 py-2.5 border-1 border-[#aaa8a8] outline-none rounded-lg focus:ring-2 focus:ring-gray-700 focus:border-gray-700 transition-colors"
            placeholder="Enter your email address"
          />
        </div>

        <div>
          <label className="block text-lg font-medium text-[#7A7A7A] mb-2">
            Type your message
          </label>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            rows={4}
            className="w-full text-lg max-w-[370px] px-4 py-2.5 border-1 border-[#aaa8a8] rounded-lg outline-none focus:ring-2 focus:ring-gray-700 focus:border-gray-700 transition-colors resize-none"
            placeholder="How can we help you?"
          />
        </div>

        <button
          onClick={handleSubmit}
          disabled={isLoading}
          className="w-full flex max-w-[370px] justify-center items-center gap-2 bg-black text-[#12F280] py-3 px-6 rounded-lg hover:bg-gray-800 transition-colors font-medium text-lg disabled:opacity-50"
        >
          {isLoading ? "Submitting..." : "Submit your Query!"}
          {!isLoading && <img src="/assets/img/CTA Arrow black.svg" alt="arrow" />}
        </button>
      </div>
    </div>
  );
};
